export default __webpack_public_path__ + "static/media/travel_pinpoint.94820376.svg";